/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { organsAPI } from 'src/api/modules/organs';
import notice from 'src/common/components/Notice';
import { usersAPI } from 'src/api/modules/users';
import { useSelector } from 'react-redux';
import { Grid, makeStyles } from '@material-ui/core';
import { sessionsAPI } from 'src/api/modules/sessions';
import { getAllOrgans } from 'src/utils/getSubOrganos';
import { useHistory, useParams } from 'react-router-dom';
import EditorText from 'src/common/components/EditorText';
import PageLayout from 'src/common/components/PageLayout';
import UtilInputs from 'src/common/components/UtilInputs';
import FileUpload from 'src/common/components/FileUpload';
import { templateNotification } from './utils/mail-template';
import CustomButton from 'src/common/components/CustomButton';
import { institutionsAPI } from 'src/api/modules/institutions';
import { action_buttons, defaultForm, form, inputFile } from './utils/data';
import { notificationsReAPI } from 'src/api/modules/notificationsResolutions';

const useStyles = makeStyles({
	subContainerButtons: {
		flexDirection: 'row',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	subTitle2: {
		fontSize: 13,
		marginTop: '10px',
		marginLeft: '10px',
	},
});

const Notification = () => {
	const { id } = useParams();
	const classes = useStyles();
	const history = useHistory();
	const [users, setUsers] = useState([]);
	const [organs, setOrgans] = useState([]);
	const [sessions, setSessions] = useState([]);
	const [nameFile, setNameFile] = useState(null);
	const { user } = useSelector((state) => state.auth);
	const [institutions, setInstitutions] = useState([]);
	const [dataForm, setDataForm] = useState(defaultForm);
	const [clearEditor, setClearEditor] = useState(false);
	const [disableFields, setDisableFields] = useState(false);
	const [loaderSend, setLoaderSend] = useState(false);
	const [content, setContent] = useState(templateNotification());
	const reduxOrgan = useSelector((state) => state.organsByRol.organs);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const showEverything = ['ADMINISTRADOR GENERAL', 'SISTEMA', 'RESPONSABLE DE NEGOCIO'];

	useEffect(() => {
		getInstitutions();
		getOrgans();
		getAllUsers();
		if (id) getNotificationID();
	}, []);

	const getInstitutions = () => {
		setInstitutions([]);
		institutionsAPI
			.get('unidadAdministrativa')
			.then((response) => {
				if (response && response.length > 0) {
					let institutionsFlag = [];
					response.forEach((ele) => {
						institutionsFlag.push({
							value: ele.id,
							text: ele.nombre,
						});
					});
					setInstitutions([...(institutionsFlag || [])]);
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};

	const getOrgans = () => {
		if (showEverything.includes(systemLevelRole) === true) {
			organsAPI
				.get('get')
				.then((response) => {
					if (response && response.length > 0) {
						setOrgans(getAllOrgans(response));
					}
				})
				.catch((e) => notice('Ocurrio un error al cargar órganos colegiados'));
		} else {
			setOrgans(reduxOrgan);
		}
	};

	const getUsersInstitutions = (institutions) => {
		setUsers([]);
		usersAPI
			.getByOrganSeveralInstitution(dataForm.idOrgano, institutions)
			.then((response) => {
				if (response && response.length > 0) {
					let usersInst = [];

					response.forEach((item) => {
						usersInst.push({
							value: item.id,
							text: `${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`,
						});
					});

					setUsers(usersInst);
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};

	const getAllUsers = () => {
		setUsers([]);
		usersAPI
			.getAllUsersStatus()
			.then((response) => {
				if (response && response.length > 0) {
					let usersFlag = [];
					response.forEach((item) => {
						usersFlag.push({
							value: item.id,
							text: ` ${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`,
						});
					});
					setUsers([...(usersFlag || [])]);
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};

	const getSessions = (organ) => {
		setSessions([]);
		sessionsAPI
			.getByOrgan(organ)
			.then((response) => {
				if (response.sesiones && response.sesiones.length > 0) {
					let newsessions = [];
					response.sesiones.forEach((item) => {
						newsessions.push({
							value: item.id,
							text: item.numero_sesion,
						});
					});
					setSessions(newsessions);
				} else
					notice(
						'No se encontraron sesiones del órgano seleccionado',
						'warning'
					);
			})
			.catch(() => {
				console.log('Ha ocurrido un problema al obtener las sesiones');
			});
	};

	const getNotificationID = () => {
		setDisableFields(true);
		notificationsReAPI
			.getNotification(id)
			.then((response) => {
				if (response.idOrgano) getSessions(response.idOrgano);
				let users = [];
				let units = [];
				response.usuarioss.forEach((item) => {
					users.push({
						value: item.id,
						text: `${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`,
					});
				});

				response.unidadesAdministrativass.forEach((item) => {
					units.push({
						value: item.id,
						text: item.nombre,
					});
				});

				let data = {
					...response,
					idOrgano: response?.idOrgano ? Number(response?.idOrgano) : '',
					idSesion: response?.idSesion ? Number(response?.idSesion) : '',
					usuarios: users,
					unidadesAdministrativas: units,
					contResponse: response.contenido,
				};

				setDataForm(data);
			})
			.catch(() => {
				notice('Ocurrió un problema al obtener la notificación');
			});
	};

	const sendNotification = () => {
		let users = [];
		let units = [];
		if (dataForm.usuarios === null || dataForm.usuarios === '') {
			return notice('El campo Usuarios es requerido', 'warning');
		}
		if (dataForm.asunto === null) {
			return notice('El campo Asunto es requerido', 'warning');
		}

		setLoaderSend(true);
		dataForm.unidadesAdministrativas.forEach((item) => {
			units.push(item.value);
		});

		dataForm.usuarios.forEach((item) => {
			users.push(item.value);
		});

		let bodySend = {
			...dataForm,
			unidadesAdministrativas: units,
			usuarios: users,
			contenido: content,
		};

		notificationsReAPI
			.createNotification(bodySend)
			.then(() => {
				notice('Notificación Enviada', 'success');
				setDataForm(defaultForm);
				history.push('/seguimiento/notificaciones');
			})
			.catch(() => {
				notice('Ocurrió un problema al enviar la notificación');
			})
			.finally(() => {
				setLoaderSend(false);
			});
	};

	const handleChange = ({ target }) => {
		const { name, value } = target;
		setDataForm({ ...dataForm, [name]: value });

		if (name === 'idOrgano') getSessions(value);

		if (name === 'unidadesAdministrativas') {
			if (value.length === 0) {
				getAllUsers();
			} else {
				let institutionsSelec = value;
				let arrayInstitutions = [];
				institutionsSelec.forEach((item) => {
					arrayInstitutions.push(item.value);
				});
				getUsersInstitutions(arrayInstitutions);
			}
		}
	};
	const fileInputRef = React.useRef();
	const onUploadClick = () => {
		fileInputRef.current.click();
	};

	const onResetData = () => {
		setNameFile();
		delete dataForm.archivo;
		fileInputRef.current.value = '';
	};

	const onFileInputChange = (event) => {
		let file = event.target.files[0];
		if (!file) {
			return;
		}

		setNameFile(file.name);
		getBase64(file);
	};

	const getBase64 = (file) => {
		return new Promise((resolve) => {
			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				const base64String = reader.result
					.replace('data:', '')
					.replace(/^.+,/, '');
				resolve(base64String);
				let file64 = { file: base64String, fileName: file.name };
				setDataForm({ ...dataForm, archivo: file64 });
			};
		});
	};

	const getDataFile = () => {
		const data = {
			idEntidad: id,
			tipo: 'N',
			entidad: 'SAOC_ENT_NOTIFICACIONES',
			ruta: dataForm?.archivoDTO?.ruta,
			title: 'Archivo adjunto',
			nombre: dataForm?.archivoDTO?.nombre,
			nombreUsuario:
				user.nombre + ' ' + user.apellidoPaterno + ' ' + user.apellidoMaterno,
			typeDownload: '',
		};

		return data;
	};

	const onClear = () => {
		setClearEditor(true);
	};

	const onCancel = () => history.push('/seguimiento/notificaciones');

	return (
		<PageLayout title="Notificación">
			<UtilInputs
				formValues={dataForm}
				inputValues={form(organs, sessions, institutions, users, disableFields)}
				onValuesChange={handleChange}
			/>
			<div className={classes.subTitle2}>Mensaje de la notificación</div>
			<Grid container className="marginBottom: 25">
				<Grid item md={12}>
					{id ? (
						dataForm.contResponse && (
							<EditorText
								defaultHTML={dataForm.contResponse}
								setValueEnd={setContent}
								disabled={disableFields}
								readOnly={true}
							/>
						)
					) : (
						<EditorText
							defaultHTML={dataForm.contenido}
							setValueEnd={setContent}
							clearEditor={clearEditor}
							setClearEditor={setClearEditor}
						/>
					)}
				</Grid>
			</Grid>
			{id === undefined && (
				<Grid
					item
					xs={12}
					md={12}
					className={'d-flex justify-content-end mt-lg-2'}
				>
					<FileUpload
						onUploadClick={() => onUploadClick()}
						name={nameFile}
						resetData={onResetData}
						id="btnFile"
					/>
				</Grid>
			)}

			{dataForm.archivoDTO && <UtilInputs inputValues={inputFile(getDataFile())} />}

			<Grid className={classes.subContainerButtons} item xs={12} md={12}>
				{action_buttons(
					sendNotification,
					onCancel,
					onClear,
					disableFields,
					loaderSend
				).map((button) => (
					<CustomButton
						key={button.title}
						mainText={button.title}
						color={button.color}
						onClick={button.onClick}
						disabled={button.disabled}
						className={button.className}
						loading={button.loading}
					/>
				))}
				<input
					id="btnFile"
					type="file"
					onChange={onFileInputChange}
					ref={fileInputRef}
					hidden
				/>
			</Grid>
		</PageLayout>
	);
};

export default Notification;
